import React from 'react'
import { useTheme } from '@mui/material/styles'
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro'
import { enUS, svSE } from '@mui/x-data-grid-pro/locales'
import { useTranslation } from 'react-i18next'
import CustomerDialog from './CustomerDialog'
import { Link } from 'react-router'
import * as datefns from 'date-fns'
import { CustomDataGridToolbar } from '../../../components/custom-grid-components/CustomDataGridToolbar'

const gridTextI18n = (locale) => {
    if (locale?.startsWith('sv')) {
        return svSE.components.MuiDataGrid.defaultProps.localeText
    } else {
        return enUS.components.MuiDataGrid.defaultProps.localeText
    }
}

const customersColumns = () => [
    {
        field: 'name',
        headerName: 'Namn',
        minWidth: 150,
        flex: 1,
        renderCell: ({ row: customer, value: name }) => {
            return <Link to={`/admin/customers/${customer.id}`}>{name}</Link>
        },
    },
    {
        field: 'userCount',
        headerName: 'Aktiverade användare (totalt)',
        minWidth: 150,
        flex: 1,
        valueGetter: (_, customer) => {
            return customer.totalUserCount - customer.disabledUserCount
        },
        renderCell: ({ row: customer }) => {
            return `${customer.totalUserCount - customer.disabledUserCount} (${customer.totalUserCount})`
        },
    },
    {
        field: 'lastActive',
        headerName: 'Senast aktiv',
        minWidth: 150,
        flex: 1,
        valueFormatter: (value) => (value ? datefns.format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : ''),
    },
    // { field: 'totalUserCount', headerName: 'Totalt antal användare', minWidth: 150, flex: 1 },
    // { field: 'disabledUserCount', headerName: 'Inaktiverade användare', minWidth: 150, flex: 1 },
]

function CustomersGrid({ customers, onUpdate }) {
    const [editCustomerDialogOpen, setEditCustomerDialogOpen] = React.useState(false)
    const [customerToEdit, setCustomerToEdit] = React.useState(null)
    const { i18n } = useTranslation()
    const locale = i18n.language

    const disableSelectedSellOutlineStyle = {
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
        },
        [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
            outline: 'none',
        },
    }
    const theme = useTheme()

    const openEditCustomerDialog = (customer) => {
        setCustomerToEdit(customer)
        setEditCustomerDialogOpen(true)
    }

    return (
        <div style={{ width: '100%' }}>
            <CustomerDialog
                customer={customerToEdit}
                open={editCustomerDialogOpen}
                onClose={() => {
                    setEditCustomerDialogOpen(false)
                }}
                onSubmit={({ id, name }) => {
                    if (onUpdate) {
                        let newList
                        if (id) {
                            newList = customers.map((customer) => {
                                if (customer.id === id) {
                                    return { ...customer, name }
                                }
                                return customer
                            })
                        } else {
                            console.log('This should not happen, we create new customers elsewhere')
                            newList = [...customers, { name }]
                        }
                        onUpdate(newList)
                    }
                    setEditCustomerDialogOpen(false)
                }}
            />
            <DataGridPro
                sx={{
                    ...disableSelectedSellOutlineStyle,
                    width: '100%',
                    '& .even': {
                        backgroundColor: theme.palette.rowColor.main, // Use palette color for even rows
                    },
                    '& .odd': {
                        // backgroundColor: theme.palette.rowColor.light, // Use palette color for odd rows
                    },
                }}
                rows={customers}
                columns={customersColumns(openEditCustomerDialog)}
                localeText={gridTextI18n(locale)}
                // Use the custom toolbar
                slots={{ toolbar: CustomDataGridToolbar }}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                // Disable column filter options
                disableColumnFilter
                // Disable column menu
                disableColumnMenu
                // Disable row selection on click
                disableRowSelectionOnClick
                showToolbar
            />
        </div>
    )
}

export default CustomersGrid
